import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "./ui/button";
import { Activity, Menu, X } from "lucide-react";
import { useAuth } from "../lib/auth.jsx";
import analytics from "../lib/analytics";

export default function SiteHeader() {
  const { user } = useAuth();
  const [open, setOpen] = React.useState(false);
  const nav = useNavigate();

  return (
    <header className="sticky top-0 z-30 bg-white/95 backdrop-blur border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="site-logo">
          <div className="w-9 h-9 rounded-md bg-[#0B5FFF] text-white flex items-center justify-center">
            <Activity className="w-5 h-5" />
          </div>
          <div className="leading-tight">
            <div className="font-heading font-extrabold text-[#111827]">RapidCare</div>
            <div className="text-[10px] tracking-widest text-slate-500 uppercase">SA</div>
          </div>
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm text-slate-700">
          <a href="/#features" data-testid="nav-features">Features</a>
          <Link to="/pricing" data-testid="nav-pricing">Pricing</Link>
          <a href="/#clinicians" data-testid="nav-clinicians">For Clinicians</a>
          <a href="/#faq" data-testid="nav-faq">FAQ</a>
        </nav>
        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <Button onClick={() => nav("/app/dashboard")} className="bg-[#0B5FFF] hover:bg-[#0A54E0]" data-testid="go-dashboard">
              Open Dashboard
            </Button>
          ) : (
            <>
              <Link to="/login" className="text-sm font-medium text-slate-700 hover:text-slate-900" data-testid="header-login">Sign in</Link>
              <Button onClick={() => { analytics.signupStart("/signup"); nav("/signup"); }} className="bg-[#0B5FFF] hover:bg-[#0A54E0]" data-testid="header-signup">
                Start free trial
              </Button>
            </>
          )}
        </div>
        <button
          className="md:hidden p-2 text-slate-700"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white px-6 py-4 space-y-3">
          <a href="/#features" className="block text-sm">Features</a>
          <Link to="/pricing" className="block text-sm">Pricing</Link>
          <a href="/#clinicians" className="block text-sm">For Clinicians</a>
          <div className="pt-2 flex gap-2">
            {user ? (
              <Button onClick={() => nav("/app/dashboard")} className="bg-[#0B5FFF] w-full">Dashboard</Button>
            ) : (
              <>
                <Button variant="outline" onClick={() => nav("/login")} className="flex-1">Sign in</Button>
                <Button onClick={() => { analytics.signupStart("/signup"); nav("/signup"); }} className="bg-[#0B5FFF] flex-1">Start free trial</Button>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
